import { completeCheckoutStep } from './complete-checkout-step';
const defaultOrder = {
    shipmentsAttributes: null,
};
export const completeDeliveryStep = (order = defaultOrder) => {
    return (dispatch) => {
        return dispatch(completeCheckoutStep({ order, state: 'delivery' }));
    };
};
